module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p10"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rp10"
    }
  }, [_vm._v("FISH STOCK")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "imagela"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "49",
      "src": "images/45ref.jpg",
      "width": "25"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("Make arrangements with the fish department of your supermarket to save fish bones for you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("Makes about 1½ quarts")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 quarts water")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2–3 pounds fish bones (from a non-oily fish, such as haddock)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 each: chopped large onion, rib celery")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("7–8 black peppercorns")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ teaspoon each: kosher or sea salt, white pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('b', [_vm._v("1.")]), _vm._v(" Heat all ingredients to boiling in large saucepan; reduce heat and simmer 30 minutes, skimming foam from surface. Strain through double layer of cheesecloth, discarding bones, vegetables, and seasonings.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Cup:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 17")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 2.8")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 0.3")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 0.1")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 191")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.0")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67ddb10b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0110.vue
// module id = 108
// module chunks = 0